import { useInterviewStore } from "../stores";
import { getUiCopy, UiCopy } from "./copy";
import { applyDocumentLanguage } from "./locale";
import { useEffect } from "react";

export const useUiCopy = (): UiCopy => {
  const uiLocale = useInterviewStore((state) => state.session.uiLocale);
  const htmlLang = useInterviewStore((state) => state.session.htmlLang);

  useEffect(() => {
    applyDocumentLanguage(htmlLang || "en");
  }, [htmlLang]);

  return getUiCopy(uiLocale);
};
